export enum Authentication {
  REQUIRE = 'require',
}
